<template>
  <md-dialog ref="viewBatchRouteModal">
    <md-dialog-content>
      <traceability-maps
        v-if="batch"
        :o-s-alvaro="exam.idOrder"
        :locations="mapLocations"
        :laboratory="{
          name: batch.laboratory.labName,
          address: batch.laboratory.address
        }"
        :nto="{
          name: 'NTO ' + (batch.nto.address?.city || ''),
          address: batch.nto.address
        }"
        :current-location="{
          address: batch.currentBatchLocation.address,
          position: {
            lat: batch.currentBatchLocation.latitude,
            lng: batch.currentBatchLocation.longitude
          },
          lastUpdated: batch.currentBatchLocation.lastUpdated
        }"
        :button-action="() => close()"
        button-label="VER AMOSTRAS"
      />
    </md-dialog-content>
  </md-dialog>
</template>

<script>
import TraceabilityMaps from '@/components/common/TraceabilityMaps'

export default {
  name: 'ViewBatchRouteModal',
  components: {
    TraceabilityMaps
  },
  props: {
    exam: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      batch: {
        osId: '1',
        examName: 'XPTO',
        laboratory: {
          labName: 'Laboratório',
          address: 'Lorem ipsum, 321'
        },
        nto: {
          address: 'Lorem ipsum, 123'
        },
        currentBatchLocation: {
          address: 'Lorem ipsum, 456',
          lastUpdated: '2025-09-25T10:00:00Z',
          latitude: -23.256909,
          longitude: -51.155745
        }
      }
    }
  },
  computed: {
    mapLocations() {
      if (!this.batch) return []
      const b = this.batch
      return [
        {
          name: 'laboratory',
          icon: b.laboratory?.icon || 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-lab.png',
          position: { lat: b.laboratory.latitude, lng: b.laboratory.longitude }
        },
        {
          name: 'transport',
          icon: 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-in-transit.png',
          position: { lat: b.currentBatchLocation.latitude, lng: b.currentBatchLocation.longitude }
        },
        {
          name: 'placeExecution',
          icon: b.nto?.icon || 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-alvaro.png',
          position: { lat: b.nto.latitude, lng: b.nto.longitude }
        }
      ]
    }
  },
  methods: {
    open() {
      /** @todo Remove this log. */
      console.log('exam', this.exam)

      this.$refs.viewBatchRouteModal.open()
    },
    close() {
      this.$refs.viewBatchRouteModal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.md-dialog) {
  width: 900px;
}
</style>
